import styled from 'styled-components';
import bgLogin from '@/main//assets/images/homepage/xnuupVan.jpg';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0;
  padding: 2rem;
  height: 100%;
  width: 100%;
  background-image: ${`url(${bgLogin})`};
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    object-position: -400px 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 1rem;
  }
`;

export const ImageLine = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  max-width: clamp(300px, 100%, 800px);
  height: 180px;
  object-fit: contain;
  z-index: -1;
`;

